export default __webpack_public_path__ + "media/color/stak-57d1e4b6.svg";